import styled from 'styled-components';
import { getTextColor, getBackgroundColor, themeGet, getBorderColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import { Close } from '@magalu/stereo-ui-icons';
import { slideFromBottom, slideFromTop, fadeIn } from '../../utils';
import Box from '../../atoms/Box';
import Flex from '../../atoms/Flex';
import AttributeRadio from '../AttributeRadio';
export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.63);
  animation: ${fadeIn} 0.3s linear;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  ${getMediaQuery('large')} {
    display: none;
  }
`;
export const Container = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: ${themeGet('zIndices.2')};
  justify-content: flex-end;

  ${getMediaQuery('large')} {
    z-index: ${themeGet('zIndices.0')};
    overflow: hidden;
    position: absolute;
    height: auto;
    top: 56px;
    bottom: unset;
  }
`;
export const Wrapper = styled(Flex)`
  width: ${props => props != null && props.fullWidth ? '100%' : '85%'};
  overflow: hidden;
  flex-direction: column;
  animation: ${slideFromBottom} 0.3s ease-in-out;
  z-index: ${themeGet('zIndices.1')};

  ${getMediaQuery('large')} {
    width: 100%;
    position: relative;
    animation: ${slideFromTop} 0.3s ease-in-out;
  }
`;
export const Paper = styled(Box)`
  background-color: ${getBackgroundColor('white')};
  position: relative;
  max-height: 250px;
  overflow: hidden;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;

  ${getMediaQuery('large')} {
    border-radius: 6px;
    border: 1px solid;
    border-color: ${getBorderColor('light')};
  }
`;
export const Header = styled(Flex)`
  justify-content: ${props => props.hasContentLabel ? 'space-between' : 'flex-end'};
  align-items: center;
  background-color: ${getBackgroundColor('base')};
  height: 47px;
  font-size: 20px;
  font-weight: 500;
  color: #515151;
  padding: 0 12px;
  line-height: 39px;

  ${getMediaQuery('large')} {
    display: none;
  }
`;
export const Body = styled(Flex)`
  flex-direction: column;
  padding-bottom: 44px;
  overflow-y: auto;
  height: calc(100% - 39px);

  ${getMediaQuery('large')} {
    padding-top: 0;
    padding-bottom: 0;
    height: 100%;
    max-height: 250px;
  }
`;
export const Footer = styled(Box)`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 5%, rgba(255, 255, 255, 1) 45%);
  position: absolute;
  width: 100%;
  height: 46px;
  bottom: 0;

  ${getMediaQuery('large')} {
    display: none;
  }
`;
export const CloseIcon = styled(Close).attrs(props => ({
  color: getTextColor('primary')(props)
}))`
  ${getMediaQuery('large')} {
    display: none;
  }
`;
export const Option = styled(AttributeRadio)`
  & ~ label {
    width: 100%;
    height: 46px;
    border: 0px;
    padding: 0 12px;
    border-radius: 0px;
    border-top-width: 1px;
    border-style: solid;
    border-color: ${getBorderColor('light')};
    color: ${getTextColor('light')};
    justify-content: space-between;
    font-weight: normal;
    line-height: 22px;
  }

  &:checked ~ label {
    background-color: transparent;
    background-color: ${getBackgroundColor('opacityBlue')};
    border-color: ${getBorderColor('light')};
    font-weight: 500;
    color: ${getTextColor('base')};

    &::before {
      content: '';
      width: 5px;
      height: 100%;
      background-color: ${getBackgroundColor('primary')};
      left: 0;
      position: absolute;
    }
  }

  &:disabled ~ label {
    background-color: ${getBackgroundColor('base')};
    color: ${getTextColor('lighter')};
  }

  ${getMediaQuery('large')} {
    &:not(:checked, :disabled) ~ label:hover {
      color: ${getTextColor('primary')};
    }

    &:disabled ~ label {
      cursor: not-allowed;
    }
  }
`;